var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M9.683,26.7a5.542,5.542,0,1,0-5.542-5.542A5.548,5.548,0,0,0,9.683,26.7Zm0-8.75a3.208,3.208,0,1,1-3.208,3.208A3.212,3.212,0,0,1,9.683,17.952ZM19.25,33.5V35.64H16.917V33.5a3.066,3.066,0,0,0-3.062-3.062H5.4A3.066,3.066,0,0,0,2.333,33.5v1.878H0V33.5a5.4,5.4,0,0,1,5.4-5.4h8.458A5.4,5.4,0,0,1,19.25,33.5Zm1.792-7.684a4.335,4.335,0,1,0-4.334-4.335A4.34,4.34,0,0,0,21.042,25.819Zm0-6.336a2,2,0,1,1-2,2A2,2,0,0,1,21.042,19.483ZM28,31.3v1.715H25.667V31.3a1.9,1.9,0,0,0-1.9-1.9H19.978a4.705,4.705,0,0,0-2.332-2.332h2.332s3.793,0,3.793,0A4.234,4.234,0,0,1,28,31.3Z",
    transform: "translate(0 -11.063)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUsers);
export default __webpack_public_path__ + "static/media/ico-users.2c18ee273df9e2b33732342384e916d2.svg";
export { ForwardRef as ReactComponent };